import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

export interface DebugPanelState {
  isDebugMode: boolean;
  debugData: any | null;
  debugLoading: boolean;
}

@Injectable({ providedIn: "root" })
export class DebugPanelService {
  public debugPanelOpen = false;

  private readonly _state$ = new BehaviorSubject<DebugPanelState>({
    isDebugMode: false,
    debugData: null,
    debugLoading: false,
  });

  public readonly state$ = this._state$.asObservable();

  public activate(): void {
    this._state$.next({
      isDebugMode: true,
      debugData: null,
      debugLoading: true,
    });
  }

  public setData(data: any): void {
    this._state$.next({
      isDebugMode: true,
      debugData: data,
      debugLoading: false,
    });
  }

  public setLoadingError(): void {
    this._state$.next({
      isDebugMode: true,
      debugData: null,
      debugLoading: false,
    });
  }

  public reset(): void {
    this._state$.next({
      isDebugMode: false,
      debugData: null,
      debugLoading: false,
    });
    this.debugPanelOpen = false;
  }
}
